<template>
  <router-link
    class="draft-product-component text-dark"
    :to="{ name: 'product-details', params: { id: product.id } }"
  >
    <div
      class="d-flex flex-column flex-md-row align-items-left align-items-md-center"
    >
      <img v-if="product.picture" class="img-fluid" :src="product.picture" />
      <img
        v-else
        class="img-fluid"
        :src="require('@/assets/images/product-example-big.svg')"
      />
      <div class="flex-fill ml-md-5 mt-5 mt-md-0">
        <div class="d-flex align-items-center">
          <div class="flex-fill">
            <h5 class="product-name fs-12">{{ product.name }}</h5>
            <div class="d-flex align-items-center text-secondary">
              <small class="fs-12">
                {{
                  product.charge_type === "recurrent"
                    ? "Assinatura"
                    : "Curso online"
                }}
              </small>
            </div>
          </div>
          <span class="draft-badge ml-3">
            Rascunho
          </span>
        </div>
      </div>
      <!-- <div class="col d-lg-none">
        <router-link
          class="btn btn-outline-primary btn-block"
          :to="{ name: 'product-details', params: { id: product.id } }"
        >
          Ir para painel do produto
        </router-link>
      </div> -->
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.draft-product-component {
  display: flex;
  text-decoration: none;
  padding: 4px;
  transition: 0.3s all ease-in-out;
  border-radius: 8px;

  // min-width: 327px;
  // @media screen and (max-width: 767px) {
  //   min-width: 288px;
  // }

  &:hover {
    background: var(--light);
  }

  img {
    height: 48px;
    width: 48px;
    @media screen and (max-width: 767px) {
      width: 272px;
      height: 98px;
    }
    object-fit: cover;
    border-radius: 8px;
    transition: 0.3s all ease-in-out;
  }

  .draft-badge {
    border-radius: var(--80, 80px);
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0.8) 100%
      ),
      #ffdb56;
    color: #ffdb56;
    height: min-content;
  }

  .badge {
    font-weight: normal;
    color: white;
  }
  .product-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
